<template>
  <v-select
    v-model="localValue"
    label="Operating System"
    outlined
    dense
    multiple
    autocomplete
    :items="operatingSystems"
    :rules="[rules.requiredMultiple]"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
  import ArrayValue from '@/components/form/mixins/arrayValue'
  import RequiredRules from '@/components/form/mixins/required'
  import UA from '@/lib/ua-parser'

  const currentOSItem = `Current OS - ${UA.os}`

  export default {
    name: 'FormOsSelect',
    mixins: [ArrayValue, RequiredRules],
    data () {
      return {
        operatingSystems: [
          currentOSItem,
          'Windows',
          'Android',
          'iOS',
          'Mac OSX',
          'Linux',
        ],
      }
    },
    created () {
      this.localValue = [currentOSItem]
    },
  }
</script>

<style lang="scss" scoped>

</style>
